import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import arrow from '../../../assets/img/icons/Arrow.png';
import arrows from '../../../assets/img/icons/Arrows.svg';
import {useTranslation} from 'react-i18next';
import {UserStat2Type} from '../../../types/TypesUser';
import s from './UserStat2.module.css';
import VeryLightGreenButton from '../../../Components/Buttons/VeryLightGreenButton';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {monthNow} from '../../../assets/utils/dateUtils';

interface UserStat2Props {
  data?: UserStat2Type;
  showStats?: boolean;
}

type StatLinkConfig = {
  translationKey: string;
  count: number;
  filters: Record<string, string | number | boolean>;
};

const UserStat2: React.FC<UserStat2Props> = ({data, showStats = true}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const month = monthNow();

  const stats: UserStat2Type = data || {
    count_child_newbie: 0,
    count_child_getlost: 0,
    count_child_getlosttree: 0,
    count_child_registration: 0,
    count_child_manager_active: 0,
    count_child_manager_nonactive: 0,
  };

  const links: StatLinkConfig[] = [
    {
      translationKey: 'Новачки в команді',
      count: stats.count_child_newbie ?? 0,
      filters: {
        not_active_contract: true,
      },
    },
    {
      translationKey: 'Зареєстровані',
      count: stats.count_child_registration ?? 0,
      filters: {
        registration_date: month,
      },
    },
    {
      translationKey: 'Втрачають контракт',
      count: stats.count_child_getlost ?? 0,
      filters: {
        old_contract: true,
      },
    },
    {
      translationKey: 'Активні партнери',
      count: stats.count_child_manager_active ?? 0,
      filters: {
        loyal_type: true,
        active_points_from: 1,
      },
    },
    {
      translationKey: 'Неактивні партнери',
      count: stats.count_child_manager_nonactive ?? 0,
      filters: {
        loyal_type: true,
        not_active: true,
      },
    },
    {
      translationKey: 'Втрачають структуру',
      count: stats.count_child_getlosttree ?? 0,
      filters: {
        old_tree: true,
      },
    },
  ];

  const renderElement = ({translationKey, filters, count}: StatLinkConfig) => {
    const defaultFilters = {
      month,
      non_filter: false,
      ...filters,
    };

    return (
      <div className={s.compoundColumn} key={translationKey}>
        <Link
          to={'/my_team'}
          state={{
            defaultFilters,
          }}
          className={s.compoundItem}
        >
          <div className={s.compoundLink}>
            {t(translationKey)}
            <span className={s.compoundOnearrow}>
              <img src={arrow} alt="arrow" />
            </span>
          </div>
          <div className={s.compoundSubrow}>
            <div className={s.compoundNumber}>{count}</div>
            <div className={s.compoundArrow}>
              <img src={arrows} alt="arrow" />
            </div>
          </div>
        </Link>
      </div>
    );
  };

  return (
    <div className={s.pageCompound}>
      {showStats && (
        <div className={s.compoundRow}>
          {links.map((linkConfig) => renderElement(linkConfig))}
        </div>
      )}
      <div className={s.actionsCompound}>
        <VeryLightGreenButton
          text={t('зареєструвати клієнта')}
          onClick={() => navigate('/registration_new_client')}
          type="button"
        />
        <LightGreenButton
          text={t('Зареєструвати партнера')}
          onClick={() => navigate('/registration_new_manager')}
          type="button"
        />
      </div>
    </div>
  );
};

export default UserStat2;
